import React, { useMemo } from 'react';
import { useGetCustomViewsQuery } from '../../../../../API/pcDashboard/CustomViewsApi';
import { ShortcutMenuItem } from './ShortcutMenuItem';
import { Paragraph } from '@zillow/constellation';

export const MenuItemList: React.FC<{ isEdit?: boolean }> = ({ isEdit }) => {
  const { data = {} } = useGetCustomViewsQuery();
  const customViews = useMemo(
    () => Object.values(data).toSorted((a, b) => a.keyboardKey.localeCompare(b.keyboardKey)),
    [data]
  );

  if (customViews.length === 0) {
    return <Paragraph>You have no custom views in localStorage</Paragraph>;
  }
  return (
    <>
      {customViews.map((shortcut) => (
        <ShortcutMenuItem key={shortcut.id} shortcut={shortcut} isEdit={isEdit} />
      ))}
    </>
  );
};
